import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

/*Import Packages */
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { SelectModule} from 'ng2-select';
import { CookieService } from 'ngx-cookie-service';

/*Import Module*/
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';

/*Import Services*/
import { AuthService } from './Services/AuthGard.service';
import { UserService} from "./Services/Users.service";
import { GlobalService } from './Services/global.service';
import { JourneyService } from './Services/journey.service';

/*Import Components*/
import { AppComponent } from './app.component';
import { AuthGuard } from './auth.guard';
import { LoginComponent} from './Screens/login/login.component';
import { NewUserComponent } from './Screens/new-user/new-user.component';
import { changepasswordComponent } from './Screens/ChangePassword/changepassword.component';
import { SafePipe } from './Screens/safe.pipe';
import { PortalComponent} from './Screens/portal/portal.component'
import { LearnerComponent } from './Screens/learner/learner.component';
import { CommunityComponent } from './Screens/community/community.component';
import { AuthorComponent } from './Screens/author/author.component';
import { TranslatorComponent } from './Screens/translator/translator.component';
import { DashboardComponent} from './Screens/dashboard/dashboard.component';
import { CommunityUserComponent } from './Screens/community-user/community-user.component';
import { UserStatusComponent } from './Screens/user-status/user-status.component';
import { ContentLauncherComponent } from './Screens/content-launcher/content-launcher.component';
import { IsolatedLoginComponent} from "./Screens/isolated-login/isolated-login.component";
import { IsolatedNewUserComponent} from "./Screens/isolated-new-user/isolated-new-user.component";
import { IsolatedProfileUpdateComponent} from "./Screens/isolated-profile-update/isolated-profile-update.component";
import { IsolatedPwdChangeComponent } from './Screens/isolated-pwd-change/isolated-pwd-change.component';
import { IsolatedScoreCardComponent } from './Screens/isolated-score-card/isolated-score-card.component';
import { IsolatedForgotPwdComponent } from './Screens/isolated-forgot-pwd/isolated-forgot-pwd.component';
import { IsolatedTendencyReportComponent } from './Screens/isolated-tendency-report/isolated-tendency-report.component';
import { IsolatedSubscriptionComponent } from './Screens/isolated-subscription/isolated-subscription.component';
import { CertificateLauncherComponent } from './Screens/certificate-launcher/certificate-launcher.component';
import {HttpErrorService} from "./Services/http-error.service";
import {AlertPopupComponent} from "./shared/popups/alert-popup/alert-popup.component";
import {BatchLinksComponent} from "./Screens/batch-links/batch-links.component";
import { ServerUnderMaintananceComponent } from './Screens/server-under-maintanance/server-under-maintanance.component';
import { UserkycComponent } from './Screens/userkyc/userkyc.component';
import { CognitoRouteComponent } from './Screens/cognito-route/cognito-route.component';
import { IdpLandingComponent } from './Screens/idp-landing/idp-landing.component';
import { ChartModule } from 'angular2-highcharts';
import * as highcharts from 'highcharts';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    changepasswordComponent,
    SafePipe,
    PortalComponent,
    CommunityComponent,
    AuthorComponent,
    TranslatorComponent,
    LearnerComponent,
    UserkycComponent,
    DashboardComponent,
    NewUserComponent,
    CommunityUserComponent,
    UserStatusComponent,
    ContentLauncherComponent,
    IsolatedLoginComponent,
    IsolatedNewUserComponent,
    IsolatedProfileUpdateComponent,
    IsolatedPwdChangeComponent,
    IsolatedScoreCardComponent,
    IsolatedForgotPwdComponent,
    IsolatedTendencyReportComponent,
    IsolatedSubscriptionComponent,
    CertificateLauncherComponent,
    BatchLinksComponent,
    ServerUnderMaintananceComponent,
    CognitoRouteComponent,
    IdpLandingComponent
   
  ],
  imports: [
    BrowserModule,
    NgxDatatableModule,
    AppRoutingModule,
    SelectModule,
    SharedModule,
    ChartModule
  ],
  providers: [AuthGuard, AuthService, UserService, GlobalService, CookieService, HttpErrorService,JourneyService],
  entryComponents: [AlertPopupComponent],
  bootstrap: [AppComponent]
})

export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts